/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SecurityLabelListResponse,
  SecurityLabelResponse,
  StringListResponse,
} from '../models/index';
import {
    SecurityLabelListResponseFromJSON,
    SecurityLabelListResponseToJSON,
    SecurityLabelResponseFromJSON,
    SecurityLabelResponseToJSON,
    StringListResponseFromJSON,
    StringListResponseToJSON,
} from '../models/index';

export interface ApplyLabelToCaseRequest {
    caseId: string;
    labelId: string;
    sessionId?: string;
}

export interface ApplyLabelToResourceRequest {
    resourceType: string;
    resourceId: string;
    labelId: string;
    sessionId?: string;
}

export interface CheckCaseAccessRequest {
    userId: string;
    caseId: string;
    sessionId?: string;
}

export interface CheckLevelAccessRequest {
    userId: string;
    securityLevel: string;
    sessionId?: string;
}

export interface CheckResourceAccessRequest {
    userId: string;
    resourceType: string;
    resourceId: string;
    sessionId?: string;
}

export interface ClearCacheRequest {
    sessionId?: string;
}

export interface ClearCaseCacheRequest {
    caseId: string;
    sessionId?: string;
}

export interface ClearGroupCacheRequest {
    groupId: string;
    sessionId?: string;
}

export interface ClearResourceCacheRequest {
    resourceType: string;
    resourceId: string;
    sessionId?: string;
}

export interface ClearUserCacheRequest {
    userId: string;
    sessionId?: string;
}

export interface CreateSecurityLabelRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface DeleteSecurityLabelRequest {
    labelId: string;
    sessionId?: string;
}

export interface DisableMacRequest {
    sessionId?: string;
}

export interface EnableMacRequest {
    sessionId?: string;
}

export interface EnforceMacPolicyRequest {
    userId: string;
    caseId: string;
    operation: string;
    sessionId?: string;
}

export interface GetAccessibleCasesRequest {
    userId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetAccessibleResourcesRequest {
    userId: string;
    resourceType: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetCacheHealthRequest {
    sessionId?: string;
}

export interface GetCacheStatusRequest {
    sessionId?: string;
}

export interface GetCaseLabelsRequest {
    caseId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetCasesByLabelRequest {
    labelId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetGroupLabelsRequest {
    groupId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetGroupsByLabelRequest {
    labelId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetMacStatusRequest {
    sessionId?: string;
}

export interface GetResourceLabelsRequest {
    resourceType: string;
    resourceId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetResourcesByLabelRequest {
    labelId: string;
    resourceType: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetSecurityLabelRequest {
    labelId: string;
    sessionId?: string;
}

export interface GetSecurityLabelsRequest {
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    name?: string;
    sessionId?: string;
}

export interface GetUserLabelsRequest {
    userId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GetUserMaxLevelRequest {
    userId: string;
    sessionId?: string;
}

export interface GetUsersByLabelRequest {
    labelId: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
    sessionId?: string;
}

export interface GrantLabelToGroupRequest {
    groupId: string;
    labelId: string;
    grantedBy: string;
    sessionId?: string;
}

export interface GrantLabelToUserRequest {
    userId: string;
    labelId: string;
    grantedBy: string;
    sessionId?: string;
}

export interface RemoveLabelFromCaseRequest {
    caseId: string;
    labelId: string;
    sessionId?: string;
}

export interface RemoveLabelFromResourceRequest {
    resourceType: string;
    resourceId: string;
    labelId: string;
    sessionId?: string;
}

export interface RevokeLabelFromGroupRequest {
    groupId: string;
    labelId: string;
    sessionId?: string;
}

export interface RevokeLabelFromUserRequest {
    userId: string;
    labelId: string;
    sessionId?: string;
}

export interface ToggleMacRequest {
    enabled: boolean;
    sessionId?: string;
}

export interface UpdateSecurityLabelRequest {
    labelId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * SecurityLabelsApi - interface
 * 
 * @export
 * @interface SecurityLabelsApiInterface
 */
export interface SecurityLabelsApiInterface {
    /**
     * Applies a security label to a specific case
     * @summary Apply security label to case
     * @param {string} caseId Case ID
     * @param {string} labelId Security label ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    applyLabelToCaseRaw(requestParameters: ApplyLabelToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Applies a security label to a specific case
     * Apply security label to case
     */
    applyLabelToCase(requestParameters: ApplyLabelToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Applies a security label to any resource type
     * @summary Apply security label to any resource
     * @param {string} resourceType Resource type (CASE, USER, GROUP, etc.)
     * @param {string} resourceId Resource ID
     * @param {string} labelId Security label ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    applyLabelToResourceRaw(requestParameters: ApplyLabelToResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Applies a security label to any resource type
     * Apply security label to any resource
     */
    applyLabelToResource(requestParameters: ApplyLabelToResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Checks if a user has access to a specific case based on MAC policies
     * @summary Check case access
     * @param {string} userId User ID to check access for
     * @param {string} caseId Case ID to check access to
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    checkCaseAccessRaw(requestParameters: CheckCaseAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Checks if a user has access to a specific case based on MAC policies
     * Check case access
     */
    checkCaseAccess(requestParameters: CheckCaseAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Checks if a user has access to a specific security level
     * @summary Check security level access
     * @param {string} userId User ID to check access for
     * @param {string} securityLevel Security level to check access to
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    checkLevelAccessRaw(requestParameters: CheckLevelAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Checks if a user has access to a specific security level
     * Check security level access
     */
    checkLevelAccess(requestParameters: CheckLevelAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Checks if a user has access to a specific resource based on MAC policies
     * @summary Check resource access
     * @param {string} userId User ID to check access for
     * @param {string} resourceType Resource type (CASE, USER, GROUP, etc.)
     * @param {string} resourceId Resource ID to check access to
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    checkResourceAccessRaw(requestParameters: CheckResourceAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Checks if a user has access to a specific resource based on MAC policies
     * Check resource access
     */
    checkResourceAccess(requestParameters: CheckResourceAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Clears the entire MAC cache
     * @summary Clear cache
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    clearCacheRaw(requestParameters: ClearCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clears the entire MAC cache
     * Clear cache
     */
    clearCache(requestParameters: ClearCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Clears MAC cache for a specific case
     * @summary Clear case cache
     * @param {string} caseId Case ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    clearCaseCacheRaw(requestParameters: ClearCaseCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clears MAC cache for a specific case
     * Clear case cache
     */
    clearCaseCache(requestParameters: ClearCaseCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Clears MAC cache for a specific group
     * @summary Clear group cache
     * @param {string} groupId Group ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    clearGroupCacheRaw(requestParameters: ClearGroupCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clears MAC cache for a specific group
     * Clear group cache
     */
    clearGroupCache(requestParameters: ClearGroupCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Clears MAC cache for a specific resource
     * @summary Clear resource cache
     * @param {string} resourceType Resource type (CASE, USER, GROUP, etc.)
     * @param {string} resourceId Resource ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    clearResourceCacheRaw(requestParameters: ClearResourceCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clears MAC cache for a specific resource
     * Clear resource cache
     */
    clearResourceCache(requestParameters: ClearResourceCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Clears MAC cache for a specific user
     * @summary Clear user cache
     * @param {string} userId User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    clearUserCacheRaw(requestParameters: ClearUserCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Clears MAC cache for a specific user
     * Clear user cache
     */
    clearUserCache(requestParameters: ClearUserCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Creates a new security label
     * @summary Create security label
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    createSecurityLabelRaw(requestParameters: CreateSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Creates a new security label
     * Create security label
     */
    createSecurityLabel(requestParameters: CreateSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Deletes a security label
     * @summary Delete security label
     * @param {string} labelId Security label ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    deleteSecurityLabelRaw(requestParameters: DeleteSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes a security label
     * Delete security label
     */
    deleteSecurityLabel(requestParameters: DeleteSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Disables the MAC system
     * @summary Disable MAC
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    disableMacRaw(requestParameters: DisableMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Disables the MAC system
     * Disable MAC
     */
    disableMac(requestParameters: DisableMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Enables the MAC system
     * @summary Enable MAC
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    enableMacRaw(requestParameters: EnableMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Enables the MAC system
     * Enable MAC
     */
    enableMac(requestParameters: EnableMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Enforces MAC policy for a specific user, case, and operation
     * @summary Enforce MAC policy
     * @param {string} userId User ID
     * @param {string} caseId Case ID
     * @param {string} operation Operation to check
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    enforceMacPolicyRaw(requestParameters: EnforceMacPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Enforces MAC policy for a specific user, case, and operation
     * Enforce MAC policy
     */
    enforceMacPolicy(requestParameters: EnforceMacPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all cases a user has access to based on MAC policies
     * @summary Get accessible cases for user
     * @param {string} userId User ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getAccessibleCasesRaw(requestParameters: GetAccessibleCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all cases a user has access to based on MAC policies
     * Get accessible cases for user
     */
    getAccessibleCases(requestParameters: GetAccessibleCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves all resources of a specific type a user has access to based on MAC policies
     * @summary Get accessible resources for user
     * @param {string} userId User ID
     * @param {string} resourceType Resource type (CASE, USER, GROUP, etc.)
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getAccessibleResourcesRaw(requestParameters: GetAccessibleResourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all resources of a specific type a user has access to based on MAC policies
     * Get accessible resources for user
     */
    getAccessibleResources(requestParameters: GetAccessibleResourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves the health status of the MAC cache
     * @summary Get cache health
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getCacheHealthRaw(requestParameters: GetCacheHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the health status of the MAC cache
     * Get cache health
     */
    getCacheHealth(requestParameters: GetCacheHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves the current MAC cache status
     * @summary Get cache status
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getCacheStatusRaw(requestParameters: GetCacheStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the current MAC cache status
     * Get cache status
     */
    getCacheStatus(requestParameters: GetCacheStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all security labels applied to a specific case
     * @summary Get case security labels
     * @param {string} caseId Case ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getCaseLabelsRaw(requestParameters: GetCaseLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all security labels applied to a specific case
     * Get case security labels
     */
    getCaseLabels(requestParameters: GetCaseLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves all cases that have a specific security label
     * @summary Get cases by security label
     * @param {string} labelId Security label ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getCasesByLabelRaw(requestParameters: GetCasesByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all cases that have a specific security label
     * Get cases by security label
     */
    getCasesByLabel(requestParameters: GetCasesByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves all security labels granted to a group
     * @summary Get group security labels
     * @param {string} groupId Group ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getGroupLabelsRaw(requestParameters: GetGroupLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all security labels granted to a group
     * Get group security labels
     */
    getGroupLabels(requestParameters: GetGroupLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves all groups that have a specific security label
     * @summary Get groups by security label
     * @param {string} labelId Security label ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getGroupsByLabelRaw(requestParameters: GetGroupsByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all groups that have a specific security label
     * Get groups by security label
     */
    getGroupsByLabel(requestParameters: GetGroupsByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves the current MAC system status
     * @summary Get MAC status
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getMacStatusRaw(requestParameters: GetMacStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the current MAC system status
     * Get MAC status
     */
    getMacStatus(requestParameters: GetMacStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all security labels applied to any resource type
     * @summary Get resource security labels
     * @param {string} resourceType Resource type (CASE, USER, GROUP, etc.)
     * @param {string} resourceId Resource ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getResourceLabelsRaw(requestParameters: GetResourceLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all security labels applied to any resource type
     * Get resource security labels
     */
    getResourceLabels(requestParameters: GetResourceLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves all resources of a specific type that have a security label
     * @summary Get resources by security label
     * @param {string} labelId Security label ID
     * @param {string} resourceType Resource type (CASE, USER, GROUP, etc.)
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getResourcesByLabelRaw(requestParameters: GetResourcesByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all resources of a specific type that have a security label
     * Get resources by security label
     */
    getResourcesByLabel(requestParameters: GetResourcesByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves a specific security label by ID
     * @summary Get security label by ID
     * @param {string} labelId Security label ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getSecurityLabelRaw(requestParameters: GetSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Retrieves a specific security label by ID
     * Get security label by ID
     */
    getSecurityLabel(requestParameters: GetSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Retrieves paginated list of security labels for the current tenant
     * @summary Get all security labels
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [name] Security label name filter
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getSecurityLabelsRaw(requestParameters: GetSecurityLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelListResponse>>;

    /**
     * Retrieves paginated list of security labels for the current tenant
     * Get all security labels
     */
    getSecurityLabels(requestParameters: GetSecurityLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelListResponse>;

    /**
     * Retrieves all security labels granted to a user
     * @summary Get user security labels
     * @param {string} userId User ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getUserLabelsRaw(requestParameters: GetUserLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all security labels granted to a user
     * Get user security labels
     */
    getUserLabels(requestParameters: GetUserLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Retrieves the maximum security level a user has access to
     * @summary Get user maximum security level
     * @param {string} userId User ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getUserMaxLevelRaw(requestParameters: GetUserMaxLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Retrieves the maximum security level a user has access to
     * Get user maximum security level
     */
    getUserMaxLevel(requestParameters: GetUserMaxLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Retrieves all users who have a specific security label
     * @summary Get users by security label
     * @param {string} labelId Security label ID
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    getUsersByLabelRaw(requestParameters: GetUsersByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>>;

    /**
     * Retrieves all users who have a specific security label
     * Get users by security label
     */
    getUsersByLabel(requestParameters: GetUsersByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse>;

    /**
     * Grants a security label to a group
     * @summary Grant security label to group
     * @param {string} groupId Group ID
     * @param {string} labelId Security label ID
     * @param {string} grantedBy User who granted the label
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    grantLabelToGroupRaw(requestParameters: GrantLabelToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Grants a security label to a group
     * Grant security label to group
     */
    grantLabelToGroup(requestParameters: GrantLabelToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Grants a security label to a user
     * @summary Grant security label to user
     * @param {string} userId User ID
     * @param {string} labelId Security label ID
     * @param {string} grantedBy User who granted the label
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    grantLabelToUserRaw(requestParameters: GrantLabelToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Grants a security label to a user
     * Grant security label to user
     */
    grantLabelToUser(requestParameters: GrantLabelToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Removes a security label from a specific case
     * @summary Remove security label from case
     * @param {string} caseId Case ID
     * @param {string} labelId Security label ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    removeLabelFromCaseRaw(requestParameters: RemoveLabelFromCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Removes a security label from a specific case
     * Remove security label from case
     */
    removeLabelFromCase(requestParameters: RemoveLabelFromCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Removes a security label from any resource type
     * @summary Remove security label from any resource
     * @param {string} resourceType Resource type (CASE, USER, GROUP, etc.)
     * @param {string} resourceId Resource ID
     * @param {string} labelId Security label ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    removeLabelFromResourceRaw(requestParameters: RemoveLabelFromResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Removes a security label from any resource type
     * Remove security label from any resource
     */
    removeLabelFromResource(requestParameters: RemoveLabelFromResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Revokes a security label from a group
     * @summary Revoke security label from group
     * @param {string} groupId Group ID
     * @param {string} labelId Security label ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    revokeLabelFromGroupRaw(requestParameters: RevokeLabelFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Revokes a security label from a group
     * Revoke security label from group
     */
    revokeLabelFromGroup(requestParameters: RevokeLabelFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Revokes a security label from a user
     * @summary Revoke security label from user
     * @param {string} userId User ID
     * @param {string} labelId Security label ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    revokeLabelFromUserRaw(requestParameters: RevokeLabelFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Revokes a security label from a user
     * Revoke security label from user
     */
    revokeLabelFromUser(requestParameters: RevokeLabelFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

    /**
     * Toggles the MAC system on or off
     * @summary Toggle MAC
     * @param {boolean} enabled Whether to enable MAC
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    toggleMacRaw(requestParameters: ToggleMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Toggles the MAC system on or off
     * Toggle MAC
     */
    toggleMac(requestParameters: ToggleMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Updates an existing security label
     * @summary Update security label
     * @param {string} labelId Security label ID
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityLabelsApiInterface
     */
    updateSecurityLabelRaw(requestParameters: UpdateSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>>;

    /**
     * Updates an existing security label
     * Update security label
     */
    updateSecurityLabel(requestParameters: UpdateSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse>;

}

/**
 * 
 */
export class SecurityLabelsApi extends runtime.BaseAPI implements SecurityLabelsApiInterface {

    /**
     * Applies a security label to a specific case
     * Apply security label to case
     */
    async applyLabelToCaseRaw(requestParameters: ApplyLabelToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling applyLabelToCase().'
            );
        }

        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling applyLabelToCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cases/{caseId}/labels/{labelId}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Applies a security label to a specific case
     * Apply security label to case
     */
    async applyLabelToCase(requestParameters: ApplyLabelToCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.applyLabelToCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Applies a security label to any resource type
     * Apply security label to any resource
     */
    async applyLabelToResourceRaw(requestParameters: ApplyLabelToResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling applyLabelToResource().'
            );
        }

        if (requestParameters['resourceId'] == null) {
            throw new runtime.RequiredError(
                'resourceId',
                'Required parameter "resourceId" was null or undefined when calling applyLabelToResource().'
            );
        }

        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling applyLabelToResource().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/resources/{resourceType}/{resourceId}/labels/{labelId}`;
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));
        urlPath = urlPath.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters['resourceId'])));
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Applies a security label to any resource type
     * Apply security label to any resource
     */
    async applyLabelToResource(requestParameters: ApplyLabelToResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.applyLabelToResourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks if a user has access to a specific case based on MAC policies
     * Check case access
     */
    async checkCaseAccessRaw(requestParameters: CheckCaseAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling checkCaseAccess().'
            );
        }

        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling checkCaseAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/access/cases/{caseId}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Checks if a user has access to a specific case based on MAC policies
     * Check case access
     */
    async checkCaseAccess(requestParameters: CheckCaseAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.checkCaseAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks if a user has access to a specific security level
     * Check security level access
     */
    async checkLevelAccessRaw(requestParameters: CheckLevelAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling checkLevelAccess().'
            );
        }

        if (requestParameters['securityLevel'] == null) {
            throw new runtime.RequiredError(
                'securityLevel',
                'Required parameter "securityLevel" was null or undefined when calling checkLevelAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/access/level/{securityLevel}`;
        urlPath = urlPath.replace(`{${"securityLevel"}}`, encodeURIComponent(String(requestParameters['securityLevel'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Checks if a user has access to a specific security level
     * Check security level access
     */
    async checkLevelAccess(requestParameters: CheckLevelAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.checkLevelAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Checks if a user has access to a specific resource based on MAC policies
     * Check resource access
     */
    async checkResourceAccessRaw(requestParameters: CheckResourceAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling checkResourceAccess().'
            );
        }

        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling checkResourceAccess().'
            );
        }

        if (requestParameters['resourceId'] == null) {
            throw new runtime.RequiredError(
                'resourceId',
                'Required parameter "resourceId" was null or undefined when calling checkResourceAccess().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/access/resources/{resourceType}/{resourceId}`;
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));
        urlPath = urlPath.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters['resourceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Checks if a user has access to a specific resource based on MAC policies
     * Check resource access
     */
    async checkResourceAccess(requestParameters: CheckResourceAccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.checkResourceAccessRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clears the entire MAC cache
     * Clear cache
     */
    async clearCacheRaw(requestParameters: ClearCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cache/clear`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears the entire MAC cache
     * Clear cache
     */
    async clearCache(requestParameters: ClearCacheRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clears MAC cache for a specific case
     * Clear case cache
     */
    async clearCaseCacheRaw(requestParameters: ClearCaseCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling clearCaseCache().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cache/clear/case/{caseId}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears MAC cache for a specific case
     * Clear case cache
     */
    async clearCaseCache(requestParameters: ClearCaseCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearCaseCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clears MAC cache for a specific group
     * Clear group cache
     */
    async clearGroupCacheRaw(requestParameters: ClearGroupCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling clearGroupCache().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cache/clear/group/{groupId}`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears MAC cache for a specific group
     * Clear group cache
     */
    async clearGroupCache(requestParameters: ClearGroupCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearGroupCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clears MAC cache for a specific resource
     * Clear resource cache
     */
    async clearResourceCacheRaw(requestParameters: ClearResourceCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling clearResourceCache().'
            );
        }

        if (requestParameters['resourceId'] == null) {
            throw new runtime.RequiredError(
                'resourceId',
                'Required parameter "resourceId" was null or undefined when calling clearResourceCache().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cache/clear/resources/{resourceType}/{resourceId}`;
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));
        urlPath = urlPath.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters['resourceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears MAC cache for a specific resource
     * Clear resource cache
     */
    async clearResourceCache(requestParameters: ClearResourceCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearResourceCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Clears MAC cache for a specific user
     * Clear user cache
     */
    async clearUserCacheRaw(requestParameters: ClearUserCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling clearUserCache().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cache/clear/user/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Clears MAC cache for a specific user
     * Clear user cache
     */
    async clearUserCache(requestParameters: ClearUserCacheRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.clearUserCacheRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new security label
     * Create security label
     */
    async createSecurityLabelRaw(requestParameters: CreateSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling createSecurityLabel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/security-labels`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new security label
     * Create security label
     */
    async createSecurityLabel(requestParameters: CreateSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.createSecurityLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a security label
     * Delete security label
     */
    async deleteSecurityLabelRaw(requestParameters: DeleteSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling deleteSecurityLabel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/{labelId}`;
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a security label
     * Delete security label
     */
    async deleteSecurityLabel(requestParameters: DeleteSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSecurityLabelRaw(requestParameters, initOverrides);
    }

    /**
     * Disables the MAC system
     * Disable MAC
     */
    async disableMacRaw(requestParameters: DisableMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/config/disable`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Disables the MAC system
     * Disable MAC
     */
    async disableMac(requestParameters: DisableMacRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.disableMacRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enables the MAC system
     * Enable MAC
     */
    async enableMacRaw(requestParameters: EnableMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/config/enable`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Enables the MAC system
     * Enable MAC
     */
    async enableMac(requestParameters: EnableMacRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enableMacRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enforces MAC policy for a specific user, case, and operation
     * Enforce MAC policy
     */
    async enforceMacPolicyRaw(requestParameters: EnforceMacPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling enforceMacPolicy().'
            );
        }

        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling enforceMacPolicy().'
            );
        }

        if (requestParameters['operation'] == null) {
            throw new runtime.RequiredError(
                'operation',
                'Required parameter "operation" was null or undefined when calling enforceMacPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['caseId'] != null) {
            queryParameters['caseId'] = requestParameters['caseId'];
        }

        if (requestParameters['operation'] != null) {
            queryParameters['operation'] = requestParameters['operation'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/policy/enforce`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Enforces MAC policy for a specific user, case, and operation
     * Enforce MAC policy
     */
    async enforceMacPolicy(requestParameters: EnforceMacPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enforceMacPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all cases a user has access to based on MAC policies
     * Get accessible cases for user
     */
    async getAccessibleCasesRaw(requestParameters: GetAccessibleCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getAccessibleCases().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/users/{userId}/accessible-cases`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all cases a user has access to based on MAC policies
     * Get accessible cases for user
     */
    async getAccessibleCases(requestParameters: GetAccessibleCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getAccessibleCasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all resources of a specific type a user has access to based on MAC policies
     * Get accessible resources for user
     */
    async getAccessibleResourcesRaw(requestParameters: GetAccessibleResourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getAccessibleResources().'
            );
        }

        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling getAccessibleResources().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/users/{userId}/accessible-resources/{resourceType}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all resources of a specific type a user has access to based on MAC policies
     * Get accessible resources for user
     */
    async getAccessibleResources(requestParameters: GetAccessibleResourcesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getAccessibleResourcesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the health status of the MAC cache
     * Get cache health
     */
    async getCacheHealthRaw(requestParameters: GetCacheHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cache/health`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the health status of the MAC cache
     * Get cache health
     */
    async getCacheHealth(requestParameters: GetCacheHealthRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCacheHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current MAC cache status
     * Get cache status
     */
    async getCacheStatusRaw(requestParameters: GetCacheStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cache/status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the current MAC cache status
     * Get cache status
     */
    async getCacheStatus(requestParameters: GetCacheStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getCacheStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all security labels applied to a specific case
     * Get case security labels
     */
    async getCaseLabelsRaw(requestParameters: GetCaseLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling getCaseLabels().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cases/{caseId}/labels`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all security labels applied to a specific case
     * Get case security labels
     */
    async getCaseLabels(requestParameters: GetCaseLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getCaseLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all cases that have a specific security label
     * Get cases by security label
     */
    async getCasesByLabelRaw(requestParameters: GetCasesByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling getCasesByLabel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/{labelId}/cases`;
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all cases that have a specific security label
     * Get cases by security label
     */
    async getCasesByLabel(requestParameters: GetCasesByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getCasesByLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all security labels granted to a group
     * Get group security labels
     */
    async getGroupLabelsRaw(requestParameters: GetGroupLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getGroupLabels().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/groups/{groupId}/labels`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all security labels granted to a group
     * Get group security labels
     */
    async getGroupLabels(requestParameters: GetGroupLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getGroupLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all groups that have a specific security label
     * Get groups by security label
     */
    async getGroupsByLabelRaw(requestParameters: GetGroupsByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling getGroupsByLabel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/{labelId}/groups`;
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all groups that have a specific security label
     * Get groups by security label
     */
    async getGroupsByLabel(requestParameters: GetGroupsByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getGroupsByLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current MAC system status
     * Get MAC status
     */
    async getMacStatusRaw(requestParameters: GetMacStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/config/status`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the current MAC system status
     * Get MAC status
     */
    async getMacStatus(requestParameters: GetMacStatusRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getMacStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all security labels applied to any resource type
     * Get resource security labels
     */
    async getResourceLabelsRaw(requestParameters: GetResourceLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling getResourceLabels().'
            );
        }

        if (requestParameters['resourceId'] == null) {
            throw new runtime.RequiredError(
                'resourceId',
                'Required parameter "resourceId" was null or undefined when calling getResourceLabels().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/resources/{resourceType}/{resourceId}/labels`;
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));
        urlPath = urlPath.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters['resourceId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all security labels applied to any resource type
     * Get resource security labels
     */
    async getResourceLabels(requestParameters: GetResourceLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getResourceLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all resources of a specific type that have a security label
     * Get resources by security label
     */
    async getResourcesByLabelRaw(requestParameters: GetResourcesByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling getResourcesByLabel().'
            );
        }

        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling getResourcesByLabel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/{labelId}/resources/{resourceType}`;
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all resources of a specific type that have a security label
     * Get resources by security label
     */
    async getResourcesByLabel(requestParameters: GetResourcesByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getResourcesByLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific security label by ID
     * Get security label by ID
     */
    async getSecurityLabelRaw(requestParameters: GetSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling getSecurityLabel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/{labelId}`;
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific security label by ID
     * Get security label by ID
     */
    async getSecurityLabel(requestParameters: GetSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.getSecurityLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of security labels for the current tenant
     * Get all security labels
     */
    async getSecurityLabelsRaw(requestParameters: GetSecurityLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of security labels for the current tenant
     * Get all security labels
     */
    async getSecurityLabels(requestParameters: GetSecurityLabelsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelListResponse> {
        const response = await this.getSecurityLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all security labels granted to a user
     * Get user security labels
     */
    async getUserLabelsRaw(requestParameters: GetUserLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserLabels().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/users/{userId}/labels`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all security labels granted to a user
     * Get user security labels
     */
    async getUserLabels(requestParameters: GetUserLabelsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getUserLabelsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the maximum security level a user has access to
     * Get user maximum security level
     */
    async getUserMaxLevelRaw(requestParameters: GetUserMaxLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling getUserMaxLevel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/users/{userId}/max-level`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves the maximum security level a user has access to
     * Get user maximum security level
     */
    async getUserMaxLevel(requestParameters: GetUserMaxLevelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getUserMaxLevelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all users who have a specific security label
     * Get users by security label
     */
    async getUsersByLabelRaw(requestParameters: GetUsersByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StringListResponse>> {
        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling getUsersByLabel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/{labelId}/users`;
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StringListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all users who have a specific security label
     * Get users by security label
     */
    async getUsersByLabel(requestParameters: GetUsersByLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StringListResponse> {
        const response = await this.getUsersByLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grants a security label to a group
     * Grant security label to group
     */
    async grantLabelToGroupRaw(requestParameters: GrantLabelToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling grantLabelToGroup().'
            );
        }

        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling grantLabelToGroup().'
            );
        }

        if (requestParameters['grantedBy'] == null) {
            throw new runtime.RequiredError(
                'grantedBy',
                'Required parameter "grantedBy" was null or undefined when calling grantLabelToGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['grantedBy'] != null) {
            queryParameters['grantedBy'] = requestParameters['grantedBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/groups/{groupId}/labels/{labelId}`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Grants a security label to a group
     * Grant security label to group
     */
    async grantLabelToGroup(requestParameters: GrantLabelToGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.grantLabelToGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Grants a security label to a user
     * Grant security label to user
     */
    async grantLabelToUserRaw(requestParameters: GrantLabelToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling grantLabelToUser().'
            );
        }

        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling grantLabelToUser().'
            );
        }

        if (requestParameters['grantedBy'] == null) {
            throw new runtime.RequiredError(
                'grantedBy',
                'Required parameter "grantedBy" was null or undefined when calling grantLabelToUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['grantedBy'] != null) {
            queryParameters['grantedBy'] = requestParameters['grantedBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/users/{userId}/labels/{labelId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Grants a security label to a user
     * Grant security label to user
     */
    async grantLabelToUser(requestParameters: GrantLabelToUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.grantLabelToUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a security label from a specific case
     * Remove security label from case
     */
    async removeLabelFromCaseRaw(requestParameters: RemoveLabelFromCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['caseId'] == null) {
            throw new runtime.RequiredError(
                'caseId',
                'Required parameter "caseId" was null or undefined when calling removeLabelFromCase().'
            );
        }

        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling removeLabelFromCase().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/cases/{caseId}/labels/{labelId}`;
        urlPath = urlPath.replace(`{${"caseId"}}`, encodeURIComponent(String(requestParameters['caseId'])));
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Removes a security label from a specific case
     * Remove security label from case
     */
    async removeLabelFromCase(requestParameters: RemoveLabelFromCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.removeLabelFromCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Removes a security label from any resource type
     * Remove security label from any resource
     */
    async removeLabelFromResourceRaw(requestParameters: RemoveLabelFromResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling removeLabelFromResource().'
            );
        }

        if (requestParameters['resourceId'] == null) {
            throw new runtime.RequiredError(
                'resourceId',
                'Required parameter "resourceId" was null or undefined when calling removeLabelFromResource().'
            );
        }

        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling removeLabelFromResource().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/resources/{resourceType}/{resourceId}/labels/{labelId}`;
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));
        urlPath = urlPath.replace(`{${"resourceId"}}`, encodeURIComponent(String(requestParameters['resourceId'])));
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Removes a security label from any resource type
     * Remove security label from any resource
     */
    async removeLabelFromResource(requestParameters: RemoveLabelFromResourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.removeLabelFromResourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revokes a security label from a group
     * Revoke security label from group
     */
    async revokeLabelFromGroupRaw(requestParameters: RevokeLabelFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling revokeLabelFromGroup().'
            );
        }

        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling revokeLabelFromGroup().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/groups/{groupId}/labels/{labelId}`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Revokes a security label from a group
     * Revoke security label from group
     */
    async revokeLabelFromGroup(requestParameters: RevokeLabelFromGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.revokeLabelFromGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revokes a security label from a user
     * Revoke security label from user
     */
    async revokeLabelFromUserRaw(requestParameters: RevokeLabelFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling revokeLabelFromUser().'
            );
        }

        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling revokeLabelFromUser().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/users/{userId}/labels/{labelId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Revokes a security label from a user
     * Revoke security label from user
     */
    async revokeLabelFromUser(requestParameters: RevokeLabelFromUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.revokeLabelFromUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Toggles the MAC system on or off
     * Toggle MAC
     */
    async toggleMacRaw(requestParameters: ToggleMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['enabled'] == null) {
            throw new runtime.RequiredError(
                'enabled',
                'Required parameter "enabled" was null or undefined when calling toggleMac().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/security-labels/config/toggle`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Toggles the MAC system on or off
     * Toggle MAC
     */
    async toggleMac(requestParameters: ToggleMacRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.toggleMacRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing security label
     * Update security label
     */
    async updateSecurityLabelRaw(requestParameters: UpdateSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SecurityLabelResponse>> {
        if (requestParameters['labelId'] == null) {
            throw new runtime.RequiredError(
                'labelId',
                'Required parameter "labelId" was null or undefined when calling updateSecurityLabel().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateSecurityLabel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/security-labels/{labelId}`;
        urlPath = urlPath.replace(`{${"labelId"}}`, encodeURIComponent(String(requestParameters['labelId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SecurityLabelResponseFromJSON(jsonValue));
    }

    /**
     * Updates an existing security label
     * Update security label
     */
    async updateSecurityLabel(requestParameters: UpdateSecurityLabelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SecurityLabelResponse> {
        const response = await this.updateSecurityLabelRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
